"use client";
import { createContext, useContext } from "react";

export interface FormFunnelAttribution {
  formFunnelId: string;
  vocationId?: string;
}

const FormFunnelAttributionContext = createContext<FormFunnelAttribution | undefined>(undefined);

export const FormFunnelAttributionProvider = FormFunnelAttributionContext.Provider;

export const useFormFunnelAttribution = () => useContext(FormFunnelAttributionContext);
